import z from 'zod';
import { CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH } from '@dealstack/shared/lib/common/business/controllingParty';
import { PersonRelationType } from '@dealstack/shared/lib/generated';
import { ADD_RELATED_PERSON_FORM_FIELDS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/RelatedPersonsSection/AddRelatedPersonDrawer/addRelatedPersonDrawer.types.ts';
import { RELATED_PERSON_RELATION_TYPES } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/RelatedPersonsSection/relatedPersonsSection.utils.ts';

export const AddRelatedPersonFormShape = z
	.object({
		[ADD_RELATED_PERSON_FORM_FIELDS.email]: z.string().min(1).email(),
		[ADD_RELATED_PERSON_FORM_FIELDS.first_name]: z.string().optional(),
		[ADD_RELATED_PERSON_FORM_FIELDS.last_name]: z.string().optional(),
		[ADD_RELATED_PERSON_FORM_FIELDS.relation_type]: z
			.nativeEnum(PersonRelationType)
			.refine((type) => RELATED_PERSON_RELATION_TYPES.includes(type)),
		[ADD_RELATED_PERSON_FORM_FIELDS.custom_relation_type]: z
			.string()
			.trim()
			.max(CONTROLLING_PARTY_CUSTOM_ROLE_MAX_LENGTH)
			.optional(),
	})
	// The free-text role is mandatory for OTHER — mirrors the API's rule.
	.superRefine((values, ctx) => {
		if (
			values[ADD_RELATED_PERSON_FORM_FIELDS.relation_type] === PersonRelationType.OTHER &&
			!values[ADD_RELATED_PERSON_FORM_FIELDS.custom_relation_type]?.trim()
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: [ADD_RELATED_PERSON_FORM_FIELDS.custom_relation_type],
				message: 'Required',
			});
		}
	});
